function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CocosIslandsFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#5EAA22",
      fillRule: "evenodd",
      d: "M0 3h24v18H0V3Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FECA00",
      fillRule: "evenodd",
      d: "m18 8.25-.75.549.1-.924-.85-.375.85-.375-.1-.924.75.549.75-.549-.1.924.85.375-.85.375.1.924L18 8.25ZM17.222 13.259l-.75.549.1-.924-.85-.375.85-.375-.1-.924.75.549.75-.549-.1.924.85.375-.85.375.1.924-.75-.549ZM19.5 17.25l-.75.549.1-.924L18 16.5l.85-.375-.1-.924.75.549.75-.549-.1.924.85.375-.85.375.1.924-.75-.549ZM20.25 10.125l-.375.274.05-.461-.425-.188.425-.188-.05-.462.375.275.375-.275-.05.463.425.187-.425.188.05.461-.375-.274ZM5.25 13.5a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#915E2B",
      d: "m4.867 11.99-.269-.189c.595-.78.438-1.87.27-2.586l1.094-.258c.252 1.067-.307 2-1.095 3.034Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FECA00",
      fillRule: "evenodd",
      d: "M14.923 14.209c-.493.847-1.278 1.231-2.328 1.231a2.845 2.845 0 0 1 0-5.69c1.2 0 2.156.42 2.595 1.562-.348-.345-.886-.58-1.69-.55-1.243 0-2.051.967-2.051 1.796 0 .828.808 1.954 2.051 1.954.625-.01 1.087-.123 1.423-.303Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#5EAA22",
      fillRule: "evenodd",
      d: "M5.25 9.555c1.243 0 2.035-.336 2.035-.75 0-.415-.792-.75-2.035-.75s-1.887.335-1.887.75c0 .414.644.75 1.887.75Z",
      clipRule: "evenodd"
    })]
  })]
}));
//# sourceMappingURL=CocosIslands.js.map